export const useNewsletterSignup = () => {
  const { t } = useI18n({ useScope: "global" });

  const email = ref();
  const emailInput = ref();

  const tcConsent = ref(false);
  const tcConsentInput = ref();

  const { execute, status } = useFetch("/api/blog/newsletter/add", {
    method: "POST",
    body: {
      email,
    },
    immediate: false,
    watch: false,
  });

  const emailValidation = formValidation.email({
    required: t("input.error.required"),
    email: t("input.error.email"),
  });

  const tcConsentValidation = formValidation.boolean(
    {
      strictValue: t("input.error.tc"),
    },
    {
      strictValue: true,
    }
  );

  const { submit } = useValidateForm({
    fields: [emailInput, tcConsentInput],
    onSubmit: () => {
      updateMarketingConsent({ email: email.value });
      execute();
    },
  });

  return {
    submit,
    status,
    email,
    emailInput,
    emailValidation,
    tcConsent,
    tcConsentInput,
    tcConsentValidation,
  };
};
